import { render, staticRenderFns } from "./NotificationDropdown.vue?vue&type=template&id=09a2eb73&scoped=true&"
import script from "./NotificationDropdown.vue?vue&type=script&lang=ts&"
export * from "./NotificationDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationDropdown.vue?vue&type=style&index=0&id=09a2eb73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a2eb73",
  null
  
)

export default component.exports